const EieBankAccountStatus = Object.assign({
  CREATION_STARTED: { title: 'Creation Started', status: 'creation_started', color: 'grey' },
  CREATED: { title: 'Created', status: 'created', color: 'blue' },
  VALIDATION_SUCCEEDED: { title: 'Validation Succeeded', status: 'validation_succeeded', color: 'grey' },
  VALIDATION_FAILED: { title: 'Validation Failed', status: 'validation_failed', color: 'red' },
  ACTIVATION_SUCCEEDED: { title: 'Activation Succeeded', status: 'activation_succeeded', color: 'grey' },
  ACTIVATION_ACCEPTED: { title: 'Activation Accepted', status: 'activation_accepted', color: 'grey' },
  ACTIVATION_REJECTED: { title: 'Activation Rejected', status: 'activation_rejected', color: 'red' },
  READY: { title: 'Ready', status: 'ready', color: 'green' },
  REMOVING: { title: 'Removing', status: 'removing', color: 'grey' },
  HIDDEN: { title: 'Hidden', status: 'hidden', color: 'red' },
});

Object.freeze(EieBankAccountStatus);

export default EieBankAccountStatus;



// WEBPACK FOOTER //
// ./src/enum/eie/EieBankAccountStatus.js